module.exports = __webpack_public_path__ + "static/img/claim-step-4.020ef87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/claim-step-4.svg
// module id = RxsD
// module chunks = 1